import React from 'react'
import { Link } from 'react-router-dom'


const Footer = () => {
    return (
        <>
        <div className='footer'>


            <div className='foot'>

                <div className='foot2'>
                    <h1>Dr. Jitendra Prasad</h1>
                    <h2>Dermetology Center</h2>

                    <p><i class="fa fa-map-marker"></i> <b>Address : </b>  Skyline Plaza 3 Susant Golf City Near Dayal Bagh Marriage Lawn Lucknow </p>
                    <p> <i class="fa fa-phone"></i> <b>Phone: </b>  +91 95656 98484</p>
                    <p> <i class="fa fa-envelope"></i> <b>Email: </b> jeetuderma17@gmail.com</p>
                    <p> <i class="fa fa-clock-o"></i> <b>Timing :   </b> 10:00 AM TO 6:00 PM </p>
                </div>

            </div>

            <div className='foot'>
                <h1> Use Link </h1>
                <Link to='/' style={{textDecoration:'none'}}><h3>Home</h3></Link>
                <Link to='/' style={{textDecoration:'none'}}><h3>About</h3></Link>
                <Link to='/' style={{textDecoration:'none'}}><h3>Contact</h3></Link>
                <Link to='/' style={{textDecoration:'none'}}><h3>Gallery</h3></Link>
                <Link to='/' style={{textDecoration:'none'}}><h3>Google Page</h3></Link>
            </div>
            <div className='foot'>
                <h1>Treatment</h1>
                <Link to='/' style={{textDecoration:'none'}}><h3>Party Peeling for Instant Glow</h3></Link>
                <Link to='/' style={{textDecoration:'none'}}><h3>Chemical Peeling</h3></Link>
                <Link to='/' style={{textDecoration:'none'}}><h3>Electro Cautery</h3></Link>
                <Link to='/' style={{textDecoration:'none'}}><h3>Radio Cautery</h3></Link>
                <Link to='/' style={{textDecoration:'none'}}><h3>Mole Removing</h3></Link>
            </div>


        </div>

        <div className='disclamer'>
            <h1>All Right Reserved  Derma Dreams  Designed By Creative Digital World</h1>
        </div>

        </>
    )
}

export default Footer
